import { jsx as _jsx } from "react/jsx-runtime";
/**
 * InspectorTooltip - the CSS inspector hover panel as a React host around
 * renderInspectorTooltip (inspectorTooltipDom.ts), for the surfaces that render
 * React: the extension's ElementHighlight, which owns the position and measures
 * this node through the forwarded ref after the renderer has filled it (child
 * layout effects run before the parent's), and the welcome illustration on the
 * extension and Team Review (WELCOME_ILLUSTRATION_TOOLTIP). Moved here from the
 * extension's pins/inspector-tooltip.tsx on 2026-10-25 so Team Review draws the
 * same host instead of a copy.
 */
import { forwardRef, useEffect, useImperativeHandle, useLayoutEffect, useRef } from 'react';
import { renderInspectorTooltip } from './inspectorTooltipDom';
/** A layout effect in a browser; on the server (the prototype generator renders the illustration with
 *  react-dom/server and fills the host itself) a plain effect, which React does not warn about. */
const useHostLayoutEffect = typeof window === 'undefined' ? useEffect : useLayoutEffect;
export const InspectorTooltip = forwardRef(function InspectorTooltip({ hoverData, isLocked, style }, ref) {
    const host = useRef(null);
    useImperativeHandle(ref, () => host.current);
    useHostLayoutEffect(() => {
        if (host.current)
            renderInspectorTooltip(host.current, hoverData, { locked: isLocked });
    }, [hoverData, isLocked]);
    return _jsx("div", { ref: host, style: style });
});
//# sourceMappingURL=InspectorTooltip.js.map